import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../utils/constants";

export default function Presentation() {
	const navigate = useNavigate();
	useEffect(() => {
		navigate(ROUTES.START_GAME, { replace: true, state: { activeScenario: 1 } });
	}, [navigate]);
	return null;
}
